<script>
  /* Executable code section of the program */
  //Tools importation

  import { onDestroy, onMount } from "svelte";
  import { isProtectedRoute, userLocalData,isOnetoOneMeetingsOn,userRealTime,isChatModalOn, isAlertOn, } from "../apis/storage";
  import {
    auth,
    getPaginatedDocuments,
    filterFuction,
    getOneDocument,
    getSpecificDocuments,
    getCollection,
    searchDocumentsByKeyword,
    listenToDocument
  } from "../apis/APIS";
  import { onAuthStateChanged } from "firebase/auth";

  //Components importation
  import Loader from "../components/Loader.svelte";
  import AttendeSocialCard from "../components/Cards/AttendeSocialCard.svelte";
  import EmptyAttendeeSocial from "../components/EmptySections/EmptyAttendeeSocial.svelte";
  import OnetoOneMeetModal from "../components/Modals/OnetoOneMeetModal.svelte";
  import ChatModal from "../components/Modals/ModalChat.svelte"
  import AlertModal from "../components/Modals/alertModal.svelte";
  import EventHomeComponent from "../components/EventHomeComponent.svelte";
  import { navigate } from "svelte-routing";

  //Auxiliary Variables
  let isLoadedContent = false;
  let lastDocument = null;
  let reservDocument = [];
  let attendeesArray = [];
  let totalAttendeesArray = [];
  let totalFilterArray = [];
  let isArrayComplete = false;
  $: dinamicDocumentsPagination = [];
  let typedValue = "";
  let windowWidth = window.innerWidth;
  let totalDocuments = 0;
  let isFilterFuction = false;
  let category = "";
  let eventsNames = [];
  let eventUser = "";
  let pathname
  let unHiddenButton = true
  let currentEvent = {}

  /* Variables for listener */
  let finalButtons 
  let isActiveMeetButton
  let isActivePolls
  let event
  let unsubscribeEvent
  let colorBtn
  let eventWallpaper

    //Funtion to filter custom buttons
    const filterButtons = (event) => {
    return event.eventButtons.filter((element) => {
    if (!element.isAvailable) return false;

    if (
      element.buttonTittle === "Meetings" &&
      $userLocalData[0].userRole === "attendee" &&
      !$userRealTime.availableMeet
    ) {
      return false;
    }

    return true;
  });
};


  //Reset function
  const resetDocuments = async () => {
    dinamicDocumentsPagination = attendeesArray;
    isFilterFuction = false;
    isArrayComplete = false;
    typedValue = "";
    lastDocument = reservDocument[0]
    unHiddenButton = true
  };

  //Function to filter data
  const filterAttendees = async (value,) => {
    isFilterFuction = true;
    unHiddenButton = false
    let categorySelect = document.querySelector(".categorySelect");
    let categoryValue = categorySelect.value;
    category = categorySelect.value;
    
    let newFilter = await searchDocumentsByKeyword("users",category,value,eventUser)    
    newFilter = newFilter.filter(element => element.id !== $userLocalData[0].id)    
    dinamicDocumentsPagination = newFilter;
  };

  //Function to get documents and create pagination
  const loadMoreAttendees = async () => {
    if (isFilterFuction) {
      //filter pagination fuction
      if (!isArrayComplete) {
        typedValue = typedValue.charAt(0).toUpperCase() + typedValue.slice(1);
        
        const { completeCollection, lastDoc } = await filterFuction(
          "users",
          totalDocuments,
          eventUser,
          category,
          typedValue,
          lastDocument
        );

        if (completeCollection === undefined || completeCollection.length < totalDocuments) {
          isArrayComplete = true;
        }

        if (completeCollection !== undefined ) {
            totalFilterArray.push(completeCollection);
            dinamicDocumentsPagination  = [...dinamicDocumentsPagination,...completeCollection];
            lastDocument = lastDoc;
            reservDocument.push(lastDoc);
        }
      }
    }

    //normal pagination function
    else {
      if (!isArrayComplete) {
        const { documents, lastDoc } = await getPaginatedDocuments(
          "users",
          eventUser,
          totalDocuments,
          lastDocument
        );
        if (documents.length === 0 || documents.length < totalDocuments) {
          isArrayComplete = true;
        }

        if (documents.length > 0) {
            totalAttendeesArray.push(documents);
            dinamicDocumentsPagination = [...dinamicDocumentsPagination,...documents];
            lastDocument = lastDoc;
            reservDocument.push(lastDoc);    
        }
      }
    }
  };

  //Function to get attendees acording to event
  const eventAttendees = async () => {
    let eventSelect = document.querySelector(".eventSelect");
    let eventValue = eventSelect.value;
    eventUser = eventValue;
    lastDocument = null;
    attendeesArray = [];
    dinamicDocumentsPagination = [];
    reservDocument = [];
    totalFilterArray = [];
    let event = eventsNames.filter(element => element.tittle === eventUser)
    pathname = event[0].id
    

    //fetch documents
    const { documents, lastDoc } = await getPaginatedDocuments(
      "users",
      eventValue,
      totalDocuments,
      lastDocument
    );
    
    totalAttendeesArray.push(documents);
    attendeesArray = documents;
    dinamicDocumentsPagination = attendeesArray;
    lastDocument = lastDoc;
    reservDocument.push(lastDoc);

    /* Listener for event */
    unsubscribeEvent = listenToDocument(
          "events",
          pathname,
          (data) => {
            event = data
        eventWallpaper = event.eventMultimedia.eventWallpaperUrl || "";
        colorBtn = event.colorEvent || "";
        currentEvent = data

        isActiveMeetButton = event.eventButtons.some((element) =>{
          return (element.buttonTittle === "Meetings")  &&
          element.isAvailable 
          });
          
        //Polls active verificator
         isActivePolls = event.eventButtons.some((element) => element.buttonTittle === "Polls" && element.isAvailable);

        //Funtion to filter custom buttons
        finalButtons = filterButtons(data);
        
          }
        );
  };

  //Function to go back
  const goBack= () => {
    window.history.back();
  }

  //Logged-in session verification
  //Initial function execution
  onMount(() => {
    onAuthStateChanged(auth, async (user) => {
      if (user) {
        window.scrollTo({ top: 0, behavior: "smooth" });
        $isProtectedRoute = true;
        pathname = window.location.pathname.split("/")[2];
        
        if (pathname !== "" && pathname !== undefined) {
        currentEvent = await getOneDocument("events",pathname)
        eventUser = currentEvent.tittle || "";
        }
        $userLocalData = await getSpecificDocuments("users","email",user.email)
        
        //Get current user
        $userRealTime = $userLocalData[0]
        if ( $userLocalData[0].userRole !== "attendee") {
          eventsNames = await getCollection("events");
          
        }

        //Screen size definition for document fetching
        if (windowWidth <= 700) {
          totalDocuments = 10;
        } else if (windowWidth > 700 && windowWidth < 1100) {
          totalDocuments = 12;
        } else {
          totalDocuments = 16;
        }

        //fetch documents
        if (eventUser !== "") {
          const { documents, lastDoc } = await getPaginatedDocuments(
            "users",
            eventUser,
            totalDocuments,
            lastDocument
          );
          totalAttendeesArray.push(documents);
          attendeesArray = documents;
          attendeesArray = documents.filter(element=>element.id !==$userRealTime.id)
          dinamicDocumentsPagination = attendeesArray;
          lastDocument = lastDoc;
          reservDocument.push(lastDoc);
          
          unsubscribeEvent = listenToDocument(
          "events",
          pathname,
          (data) => {
            event = data
        eventWallpaper = event.eventMultimedia.eventWallpaperUrl || "";
        colorBtn = event.colorEvent || "";

        isActiveMeetButton = event.eventButtons.some((element) =>{
          return (element.buttonTittle === "Meetings")  &&
          element.isAvailable 
          });
          
        //Polls active verificator
         isActivePolls = event.eventButtons.some((element) => element.buttonTittle === "Polls" && element.isAvailable);

        //Funtion to filter custom buttons
        finalButtons = filterButtons(data);
        
          }
        );
        }
        //Set timer
        setTimeout(() => (isLoadedContent = true), 1500);
      } else {
        navigate("/");
      }
    });
  });

  onDestroy(() => {
    if (unsubscribeEvent) unsubscribeEvent() // Clean listener
  });

  /* End of the section */
</script>

<!-- Section to place the HTML code -->
{#if $isProtectedRoute}
  {#if isLoadedContent}
    <body class="sectionContainer">
      <div class="backBtnContainer">
        <button class="backBtn" on:click="{goBack}"> <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-left" viewBox="0 0 16 16">
          <path fill-rule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8"/>
        </svg> Go Back</button>
      </div>

      {#if Object.keys(currentEvent).length > 0}
      <!-- Header page -->
      <div
      class="headerInformation"
      style="--event-Wallpaper: {eventWallpaper}; background-image: url({eventWallpaper});"
    >
      <div class="imgContainer">
        <img src={currentEvent.eventMultimedia.eventImgUrl} alt="event poster" />
      </div>
      <div class="meetingsBtns">
        <button
          class="actionBtn"
          on:click={() => navigate(`/myChats/${currentEvent.id}/${currentEvent.tittle}`)}
          on:keypress={() =>
            navigate(`/myChats/${currentEvent.id}/${currentEvent.tittle}`)}
          style="--event-color: {colorBtn};">Chats</button
        >
        {#each currentEvent.eventButtons as button}
        {#if button.isAvailable}
        {#if $userRealTime.userRole !== "attendee"}
        {#if button.buttonUrl.slice(0, 1) === "#"}
          <button
            on:click={()=>document.getElementById(`${button.buttonUrl.slice(1)}`).scrollIntoView({ behavior: "smooth" })}
            on:keypress={document
              .getElementById(`${button.buttonUrl.slice(1)}`)
              .scrollIntoView({ behavior: "smooth" })}
            class="actionBtn"
            style="--event-color: {colorBtn};"
            >{button.buttonTittle}
          </button>
        {:else}
          <a href={button.buttonUrl} target="_blank" rel="noopener noreferrer">
            <button class="actionBtn" style="--event-color: {colorBtn};"
              >{button.buttonTittle}
            </button>
          </a>
        {/if}
      {:else if !button.isAssignedButton}
      {#if button.buttonUrl.slice(0, 1) === "#"}
          <button
            on:click={()=>document.getElementById(`${button.buttonUrl.slice(1)}`).scrollIntoView({ behavior: "smooth" })}
            on:keypress={document
              .getElementById(`${button.buttonUrl.slice(1)}`)
              .scrollIntoView({ behavior: "smooth" })}
            class="actionBtn"
            style="--event-color: {colorBtn};"
            >{button.buttonTittle}
          </button>
        {:else}
        <a href={button.buttonUrl} target="_blank" rel="noopener noreferrer">
          <button class="actionBtn" style="--event-color: {colorBtn};"
            >{button.buttonTittle}
          </button>
        </a>
        {/if}
      {:else if button.isAssignedButton && $userRealTime.customButtons.includes(button.id)}
        <a href={button.buttonUrl} target="_blank" rel="noopener noreferrer">
          <button class="actionBtn" style="--event-color: {colorBtn};"
            >{button.buttonTittle}
          </button>
        </a>
      {/if}
        {/if}
          
        {/each}
      </div>
    </div>
    <!-- End Section -->
      {/if}
      
      <div class="headerSection">
        <h1>Event Attendees</h1>
      </div>

      <div class="filterBottonsContainer">
        {#if $userLocalData[0].userRole === "administrator" || $userLocalData[0].userRole === "coordinator"}
          <div class="form-floating">
            <select
              class="form-select eventSelect"
              name="country"
              id="floatingSelect"
              aria-label="Floating label select example"
              on:change={eventAttendees}
            >
              <option selected>Select a event</option>
              {#each eventsNames as event}
                <option value={event.tittle}>{event.tittle}</option>
              {/each}
            </select>
            <label for="floatingSelect">Event</label>
          </div>
        {/if}
        <div class="form-floating">
          <select
            class="form-select categorySelect"
            name="company"
            id="floatingSelect"
            aria-label="Floating label select example"
          >
            <option selected value="">Select a category</option>
            <option value="name">Name</option>
            <option value="surname">Surname</option>
            <option value="country">Country</option>
            <option value="company">Company</option>
            <option value="jobtittle">Jobtittle</option>
          </select>
          <label for="floatingSelect">Categories</label>
        </div>
        <div class="form-floating">
          <input
            type="text"
            class="form-control"
            id="floatingInput"
            placeholder="Search"
            bind:value={typedValue}
            on:input={()=> filterAttendees(typedValue)}
          />
          <label for="floatingInput">Search</label>
        </div>
        <!-- <button
          class="actionButton filterBtn"
          on:click={() => filterAttendees(typedValue)}
          on:keypress={() => filterAttendees(typedValue)}
          >Search</button
        > -->
        <button
          class="actionButton filterBtn"
          on:click={() => {
            resetDocuments();
          }}
          on:keypress={() => resetDocuments(typedValue)}>Reset</button
        >
      </div>
      <div class="bodySection">
        {#if dinamicDocumentsPagination.length > 0}
          {#each dinamicDocumentsPagination as attendee}
            <AttendeSocialCard {attendee} />
          {/each}
        {:else}
          <EmptyAttendeeSocial />
        {/if}
      </div>
      {#if unHiddenButton}
      {#if !isArrayComplete}
      <div class="paginationBtns">
        <button class="actionButton filterBtn" on:click={loadMoreAttendees}
          >Load More Attendees</button
        >
      </div>
      {/if}
      {/if}
    </body>
  {:else}
    <Loader />
  {/if}
{/if}

{#if $isAlertOn}
<AlertModal/>
{/if}
{#if $isOnetoOneMeetingsOn}
<OnetoOneMeetModal />
{/if}
{#if $isChatModalOn}
  <ChatModal/>
{/if}

<!-- End of the section -->
<style>
  /* Section to place the code styles */
  /* Principal styles */
  body {
    width: 100%;
    height: auto;
    padding: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #f4f4f4;
  }
  /* Back btn styles */
  .backBtnContainer{
    width: 90%;
    display: flex;
    justify-content: flex-start;
  }
  .backBtn{
    background-color: #f4f4f4;
    border: none;
  }
  .backBtn:hover{
    color: #ed2824;
    border-bottom: 1px solid #ed2824;
  }
  
  /* Hedaer styles */
  .headerInformation {
    width: 90%;
    background-size: cover;
    background-position: center;
    display: flex;
    padding: 25px;
    margin: 10px 0;
  }
  .imgContainer {
    width: 50%;
  }
  .meetingsBtns {
    background-color: rgba(0, 0, 0, 0.425);
    width: 70%;
    max-height: 50vh;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    margin: 0;
  }
  .actionBtn {
    width: 200px;
    height: 50px;
    font-size: 20px;
    font-weight: 400;
    border-radius: 12px;
    padding: 8px 16px;
    color: var(--event-color);
    border: 1px solid var(--event-color);
    transition: all 0.3s ease-in-out;
    margin: 0 10px;
    background-color: white;
  }

  .actionBtn:hover {
    cursor: pointer;
    box-shadow: #000 0px 0px 5px;
    transform: scale(1.01);
    border-color: #fff;
    background-color: var(--event-color);
    color: White;
  }
  img {
    width: 85%;
    height: auto;
  }
  /* Header Styles */
  .headerSection {
    width: 90%;
    padding: 15px;
    border-bottom: 1px solid gray;
  }
  .bodySection {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    width: 90%;
    height: auto;
    padding: 15px;
  }
  .filterBottonsContainer {
    width: 90%;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-end;
    padding: 10px 0;
  }
  .form-floating {
    margin: 0 10px;
    width: 250px;
  }
  .filterBtn {
    height: 40px;
    width: 100px;
  }
  .actionButton {
    width: 200px;
    border-radius: 12px;
    font-size: 14px;
    font-weight: 500;
    padding: 8px 16px;
    background-color: white;
    color: #111;
    border: 1px solid #444;
    transition: all 0.3s ease-in-out;
    margin: 0 10px;
  }

  .actionButton:hover {
    cursor: pointer;
    box-shadow: #000 0px 0px 5px;
    transform: scale(1.01);
    border-color: #fff;
    background-color: #ed2824;
    color: White;
  }
  .paginationBtns {
    width: 90%;
    height: auto;
    padding: 20px;
    display: flex;
    justify-content: center;
  }

  /* /////////Tablets///////// */
  @media (min-width: 700px) and (max-width: 1100px) {
    .bodySection {
      width: 100%;
      height: auto;
      padding: 15px 5px;
    }
    .headerSection {
      width: 100%;
      padding: 10px;
    }
    .filterBottonsContainer {
      width: 100%;
    }
    .meetingsBtns {
      background-color: rgba(0, 0, 0, 0.425);
      width: 100%;
      height: auto;
      max-height: 15dvh;
      overflow: auto;
      display: flex;
      flex-direction: row;
      justify-content: center;
      padding: 10px 0;
    }
    img {
      width: 100%;
      height: auto;
    }
    .actionBtn {
      margin: 5px;
    }
  }
  /* /////////Cellphones ///////// */
  @media (max-width: 700px) {
    .filterBottonsContainer {
      width: 100%;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
      padding: 10px;
    }
    .form-floating {
      margin: 5px 0;
      width: 100%;
    }
    .filterBtn {
      font-size: 20px;
      padding: 10px;
      height: auto;
      width: 100%;
      margin: 10px 0;
    }

    .paginationBtns {
      width: 90%;
      height: auto;
      padding: 20px;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .bodySection {
      width: 100%;
      height: auto;
      padding: 15px 5px;
    }
    .headerInformation {
      width: 100%;
      height: auto;
      max-height: 2000dvh;
      flex-direction: column;
      align-items: center;
      padding: 0;
    }
    .imgContainer {
      width: 100%;
      display: flex;
      justify-content: center;
    }
    .meetingsBtns {
      background-color: rgba(0, 0, 0, 0);
      width: 100%;
      height: auto;
      max-height: auto;
      display: flex;
      flex-direction: row;
      justify-content: center;
      padding: 20px 0;
    }
    .actionBtn {
      width: 150px;
      height: auto;
      font-size: 20px;
      font-weight: 500;
      padding: 10px 0;
      background-color: white;
      margin: 5px;
    }
  }

  /* End of the section */
</style>
